import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatButtonModule} from "@angular/material/button";
import {UploadImageComponent} from "./upload-image.component";
import {MatProgressBarModule} from "@angular/material/progress-bar";



@NgModule({
  declarations: [UploadImageComponent],
  imports: [
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    NgOptimizedImage,
    MatProgressBarModule
  ],
  exports: [
    UploadImageComponent
  ]
})
export class UploadImageModule {
}
